import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { LoadingContainer } from "go-core/components/Loading";
import { organizationApi } from "../../../../../../../services/Api/Organization/organizationApi";
import { SupportAccessOrganizationApplicationLogApi } from "../../../../../../../services/support/types";
import SupportAccessForm from "./SupportAccessForm/SupportAccessForm";
import SupportAccessHistoryTable from "./SupportAccessHistoryTable";

interface Props {
	title: string;
}

export interface OrganizationApplicationAccesses {
	id: number;
	permissions: string[];
	type: string;
	support_access_to?: string;
	enable_access?: string;
}

const SupportAccessPreview = ({ title }: Props) => {
	const { t } = useTranslation();
	const { addFlash } = useFlash();
	const [supportAccess, setSupportAccess] = useState<OrganizationApplicationAccesses[] | undefined>(undefined);
	const [loading, setLoading] = useState<boolean>(false);
	const [historyAccess, setHistoryAccess] = useState<SupportAccessOrganizationApplicationLogApi[]>([]);

	useEffect(() => {
		init();
	}, []);

	const init = async () => {
		await fetchOrganizationSupportAccess();
		await fetchAccessHistory();
	};

	const fetchOrganizationSupportAccess = async () => {
		setLoading(true);
		try {
			const res = await organizationApi.getSupportAccess();
			setSupportAccess(res.applications);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
		setLoading(false);
	};

	const fetchAccessHistory = async () => {
		try {
			const res = await organizationApi.getOrganizationSupportAccessLogs();
			setHistoryAccess(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (loading || !supportAccess) return <LoadingContainer />;

	return (
		<div className="content">
			<div className="content-preview">
				<Header title={title} />
				<div className="row">
					<div className={"col-12"}>
						<h5>{t("modules.organization_access.field.give_access.title")}</h5>
						<p>{t("modules.organization_access.field.give_access.description")}</p>
						<SupportAccessForm
							appsAccesses={supportAccess}
							handleRefreshHistoryTable={fetchAccessHistory}
						/>
						<SupportAccessHistoryTable historyAccess={historyAccess} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default SupportAccessPreview;
